import { createRoot } from 'react-dom/client';
import { useCookies } from 'react-cookie';
import {StrictMode, useRef, useState, useEffect} from "react";

/** @type {HTMLDialogElement} */
const EMAIL_GATE_COOKIE = 'emailGate'
const popup = document.querySelector('dialog.apartment-details-popup');
const panel = popup.querySelector('.panel');
let panelBounds = panel.getBoundingClientRect();
let cursor = {x: 0, y: 0};

const isMobile = () => window.innerWidth < 960;

const root = createRoot(panel);
/**
 * @param {HTMLDialogElement} popupDialogElm
 * @param {boolean} force
 */
export const togglePopup = (popupDialogElm, force = undefined) => {
  if (force === undefined) {
    popupDialogElm.open ? popupDialogElm.close() : popupDialogElm.show();
  } else {
    force ? popupDialogElm.show() : popupDialogElm.close();
  }
};

export const updatePopup = (popupDialogElm, floorplan, bedrooms, bathrooms, title, unit_number, availability, rent, tour_url, inquire_link, sqft, isFurnished) => {
  const closeHandle = () => togglePopup(popupDialogElm, false);

  root.render(
    <StrictMode>
      <Popup
        closeHandle={closeHandle}
        floorplan={floorplan}
        bedrooms={bedrooms}
        bathrooms={bathrooms}
        title={title}
        unit_number={unit_number}
        availability={availability}
        rent={rent}
        tour_url={tour_url}
        inquire_link={inquire_link}
        sqft={sqft}
        isFurnished={isFurnished}
      />
    </StrictMode>
  );
  panelBounds = panel.getBoundingClientRect();
};

const Popup = ({closeHandle, floorplan, bedrooms, bathrooms, title, unit_number, availability, rent, tour_url, inquire_link, sqft, isFurnished}) => {
  const zoomMax = 4;
  const [zoom, setZoom] = useState(1);
  /** @type {MutableRefObject<HTMLElement>} */
  const floorplanRef = useRef(null);
  const [cookies, setCookie] = useCookies([EMAIL_GATE_COOKIE]);

  const zoomIn = () => setZoom(zoom < zoomMax ? zoom + 1 : zoom);
  const zoomOut = () => setZoom(zoom > 1 ? zoom - 1 : 1);

  const [pointerInFloorplan, setPointerInFloorplan] = useState(false);
  const [pointerInZoom, setPointerInZoom] = useState(false);
  const [isWalkthru, setIsWalkthru] = useState(false);

  const updateZoom = (e) => {
    if(e.pointerType === "mouse" || e.pointerType === "pen") {
      cursor.x = e.clientX;
      cursor.y = e.clientY;
    }else {
      cursor.x += e.movementX;
      cursor.x += e.movementY;
    }


    setPointerInFloorplan(true);
    if(zoom > 1 && !pointerInZoom) {
      const fpBounds = floorplanRef.current.getBoundingClientRect();
      const pointerCenter = {
        x: ((cursor.x - panelBounds.left) / panelBounds.width) - .5,
        y: ((cursor.y - panelBounds.top) / (panelBounds.height - 200)) - .5
      };

      floorplanRef.current.style.translate =
        (pointerCenter.x * (fpBounds.width/2)) * -1 + 'px ' + (pointerCenter.y * (fpBounds.height/2)) * -1 + 'px';
    }else{
      setPointerInFloorplan(false);
      resetFloorplanPosition();
    }
  }

  const pointerLeaveFloorplan = () => {
    setPointerInFloorplan(false);
    resetFloorplanPosition();
  }

  const handlePointerAtZoom = (isOver) => {
    setPointerInZoom(isOver);
    if(isOver) {
      setPointerInFloorplan(false);
      resetFloorplanPosition();
    }
  }

  const close = () => {
    setZoom(1);
    resetFloorplanPosition();
    closeHandle();
  };

  const resetFloorplanPosition = () => {
    if (floorplanRef?.current) {
      floorplanRef.current.style.transform = ''; 
    }
  };


  useEffect(() => {
    if(cookies[EMAIL_GATE_COOKIE]){
      jQuery('.email-gate').hide()

      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 400); //400 is max cache expiry
      setCookie(EMAIL_GATE_COOKIE,true, {expires: expireDate})
    }else{
      jQuery('.email-gate').show()
    }
  }, [cookies]);

  useEffect(() =>  {
    jQuery(document).on("gform_confirmation_loaded", function (e, form_id) {
      if(form_id != 5) return
      // Code to run upon successful form submission
      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 400); //400 is max cache expiry
      setCookie(EMAIL_GATE_COOKIE,true, {expires: expireDate})
      jQuery('.email-gate').hide()
    });

  }, [])

  useEffect(() => {

  }, [])
  return <>
    <button className="close" onClick={close}></button>
    <div className={`floorplan ${!cookies[EMAIL_GATE_COOKIE] ? 'gated' : ''}`}
      onPointerMove={updateZoom}
      onPointerLeave={pointerLeaveFloorplan} >

      {!isWalkthru &&
        <>
          <img src={floorplan?.sizes?.medium} className={`zoom-${(pointerInFloorplan || pointerInZoom || isMobile()) ? zoom : 1} ${pointerInFloorplan ? 'hover' : ''}`} ref={floorplanRef} alt={floorplan?.alt} loading={"lazy"} />
          <nav className="zoom"
               onPointerEnter={()=>handlePointerAtZoom(true)}
               onPointerLeave={()=>handlePointerAtZoom(false)}
          >
            <span className={`zoomLevel ${(pointerInFloorplan || pointerInZoom || isMobile()) ? 'active' : ''}`}>{zoom}x</span>
            <button className="in" onClick={zoomIn} disabled={zoom === 4}></button>
            <button className="out" onClick={zoomOut} disabled={zoom === 1}></button>
          </nav>
        </>
      }
      {isWalkthru &&
        <>
          <iframe src={`${tour_url.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=','embed/')}`}               title="YouTube video player" frameBorder="0"
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
               referrerPolicy="strict-origin-when-cross-origin" allowFullScreen width="100%" height="100%"></iframe>
        </>
      }
      {/*<embed src={floorplan?.sizes?.medium} className={`zoom-${(pointerInFloorplan || pointerInZoom || isMobile()) ? zoom : 1} `} ref={floorplanRef} width="100%" height="100%" />*/}

    </div>
    <div className={`info ${!cookies[EMAIL_GATE_COOKIE] ? 'gated' : ''}`}>
      <h3 className="title">
      {isFurnished ? 'Furnished ' : ''}{bedrooms} | {bathrooms} Bath{parseInt(bathrooms) > 1 ? 's' : ''}{sqft > 0 ? ' | ' + sqft + ' Sqft' : ''}
      </h3>

      <div className="description">
        <span className="type">Floorplan {title}<br />Apartment {unit_number}</span>
        <span className="availability">{availability}{isFurnished ? ' | Furnished' : ''}</span>
      </div>

      <span className="rent">{rent}</span>
      {tour_url && <span className="walkthru" onClick={() => setIsWalkthru(!isWalkthru)}>
        {!isWalkthru &&
          <>Walkthru
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 8.61902L1.5 11.619M1.5 11.619L4.5 14.619M1.5 11.619H21.5M8.5 4.61902L11.5 1.61902M11.5 1.61902L14.5 4.61902M11.5 1.61902V21.619M14.5 18.619L11.5 21.619M11.5 21.619L8.5 18.619M18.5 8.61902L21.5 11.619M21.5 11.619L18.5 14.619" stroke="#AA5D3D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        </>}
        {isWalkthru && <>Floorplan</>}
      </span>}
      <a className="inquire" href="https://www.on-site.com/apply/property/587213" target="_blank">Apply now</a>
    </div>
  </>;
};
